import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { ReactComponent as AddIllustration } from "icons/addIllustration.svg";
import { ReactComponent as SearchIllustration } from "icons/searchIllustration.svg";
import { func } from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal, showModal } from "slices/app/actions/modals";

import ChooserCard from "../ChooserCard";
import { goToOpportunitySearchModal } from "../confModalTypes";
import classes from "./NewOpportunityChooserModal.module.scss";

const NewOpportunityChooserModal = ({ onAddManually }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () =>
    dispatch(hideModal(modalTypes.NEW_OPPORTUNITY_CHOOSER));

  const handleFindOnSearch = () => {
    handleClose();
    dispatch(
      showModal(
        modalTypes.CONFIRMATION,
        goToOpportunitySearchModal(dispatch, navigate, onAddManually)
      )
    );
  };

  const handleAddManually = () => {
    dispatch(hideModal(modalTypes.NEW_OPPORTUNITY_CHOOSER));
    onAddManually();
  };

  return (
    <Modal
      data-testid="new-opportunity-chooser-modal"
      className={`fade-in ${classes.modal}`}
      show
      centered
      backdrop
      onDismiss={handleClose}
    >
      <Modal.Header>New Opportunity</Modal.Header>

      <Modal.Body>
        <p className={classes.subtitle}>How do you want to add one?</p>

        <div className={classes.cards}>
          <ChooserCard
            ariaLabel="Find on Opportunity Search"
            illustration={SearchIllustration}
            title="Find on Opportunity Search"
            subtitle="Search SAM.gov, eBuy & more"
            onClick={handleFindOnSearch}
            recommended
          />
          <ChooserCard
            ariaLabel="Add Manually"
            illustration={AddIllustration}
            title="Add Manually"
            subtitle="Enter the details yourself"
            onClick={handleAddManually}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l3} onClick={handleClose}>
          Cancel
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

NewOpportunityChooserModal.propTypes = {
  onAddManually: func.isRequired,
};

export default NewOpportunityChooserModal;
